var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container fluid",staticStyle:{"overflow-y":"scroll","height":"60vh"}},[_c('vplayer',{attrs:{"playerOptions":{
        type: 'application/x-mpegURL',//媒体类型，m3u8请给application/x-mpegURL或者application/vnd.apple.mpegURL，其他的会默认为普通音视频，注：微信不支持m3u8
        src: _vm.url_test,//视频地址
        preload: true,//是否预下载，默认为true
        autoplay: false,//是否自动播放（兼容性不太好），默认为false
        isLoop: false,//是否循环，默认不循环
        playsinline: false, //h5是否行内播放，默认false，有兼容性问题
        poster: 'https://oimdztrab.qnssl.com/Frp4SyVe5PosdkUKRaE-krjK7B5z',
        controls: 'progress,current,durration,volume', //显示的控件,volume只有视频有，没有配置controls项则全部显示。
        crossOrigin: false //设置视频的 CORS 设置。
      }},on:{"onplay":_vm.play}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf3da6a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/test3.vue
// module id = null
// module chunks = 